import React, {useEffect, useState} from "react";
import {
    CircularProgress,
    Paper
} from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import {fetchExamsCsvFile} from "../../../services/Exams/ExamsService";
import { dateUTCToLocale } from "../../../Utils/Date";

const PetitionsCoordinatorView = () => {
    const [loading,setLoading] = useState(false)
    const [data, setData] = useState([])

    const columns =[
        {
            label: 'Id',
            name: "id"
        },
        {
            label: "Usuario",
            name: "userId"
        },
        {
            label: "Examen",
            name: "examId"
        },
        {
            label: "Curso",
            name: "courseId"
        },
        {
            label: "Sede",
            name: "headquarterId"
        },
        {
            label: "Fecha de peticion",
            name: "created",
            options: {
                customBodyRender: date => dateUTCToLocale(date)
            }
        }
    ]
    const options={
        selectableRows: "none",
        print: false,
        download:true,
        elevation: 0,
        onDownload: (buildHead, buildBody, columns, data) => {
            fetchExamsCsvFile()
            return false
        },
    }

    const fetchChoices = async () => {
        setLoading(true);
        let sessionId = sessionStorage.getItem("sessionId");
        let headers = new Headers({
            'Authorization': 'Bearer ' + sessionId
        });
        const choices = await fetch(`/exams-api/requests/active`, {headers: headers})
            .then(r => r.json())
            .catch(reason => {
                console.log(reason);
                return [
                    {
                        courseId: "UCAVILA",
                        courseName: "Ucavila",
                        created: "2021-03-31T14:52:16",
                        examId: 2,
                        examOption: "A",
                        examDate: "2021-03-31T14:52:16",
                        headquarterId: "cntr_exam_99",
                        headquarterName: "EXAMEN ONLINE",
                        id: 62,
                        name: "Alumno UCAV",
                        userId: "alumnoucav"
                    },
                    {
                        courseId: "UCAVILA",
                        courseName: "Ucavila",
                        created: "2021-03-31T14:52:16",
                        examId: 2,
                        examOption: "A",
                        examDate: "2021-03-31T14:52:16",
                        headquarterId: "cntr_exam_99",
                        headquarterName: "EXAMEN ONLINE",
                        id: 62,
                        name: "Alumno UCAV",
                        userId: "alumnoucav"
                    },
                ];
            });
        setData(choices)
        setLoading(false);
    }

    useEffect( ()=>{
        fetchChoices()
    },[])

    return (
        <Paper elevation={3} style={{ padding:"25px",margin:"25px" }}>
            { loading === true
                ? <CircularProgress/>
                : <MUIDataTable
                    title={"Titulo"}
                    columns={columns}
                    options={options}
                    data={data}/>
            }
        </Paper>
    )
}

export default PetitionsCoordinatorView
